import { LuxButton, VisionXIconWhite } from '@gemini/fe-ds-core';
import { FooterCtaDTO } from '@utils/interfaces';
import { FooterWrapper, LinksWrapper } from './PageFooter.styles';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import useGetTextColor from '@hooks/useGetTextColor';
import { useMemo } from 'react';

export interface FooterProps {
  externalLinks: FooterCtaDTO[];
  isForTypWidget?: boolean;
  showLogo?: boolean;
  disablePointer?: boolean;
  footerBgColor?: string;
  footerTextColor?: string;
}

const PageFooter = ({
  externalLinks,
  isForTypWidget = false,
  showLogo = false,
  disablePointer = false,
  footerBgColor,
  footerTextColor,
}: FooterProps) => {
  const { getTextColor } = useGetTextColor();

  const secondaryColor =
    useOnlineBookingStore(
      state => state.generalConfig?.customization?.secondaryColor,
    ) ?? footerBgColor;

  const textColor = useMemo(() => {
    return getTextColor(secondaryColor);
  }, []);

  return (
    <FooterWrapper
      role="contentinfo"
      isForTypWidget={isForTypWidget}
      color={secondaryColor}
      showLogo={showLogo}
      className="ob-no-print"
    >
      {showLogo && <VisionXIconWhite />}
      <LinksWrapper>
        {externalLinks &&
          externalLinks.map((link, index) => (
            <LuxButton
              key={index}
              variant="link"
              size="small"
              style={{
                color: textColor,
                pointerEvents: disablePointer ? 'none' : 'visible',
              }}
              onClick={() => !isForTypWidget && window.open(link.url)}
              textColor={footerTextColor ? footerTextColor : textColor}
              // key={link.label}
            >
              {link.label}
            </LuxButton>
          ))}
      </LinksWrapper>
    </FooterWrapper>
  );
};

export default PageFooter;
